import { Injectable } from '@angular/core';
import { HubService } from '@app/core/hubs/hub.service';
import { environment } from '../../../../../../environments/environment';
import { MessageNotificationViewModel } from '@app/pages/constructor/constructor-components/communication-chart/models/message-notification-view.model';

@Injectable()
export class CommunicationChartPanelHubService extends HubService<MessageNotificationViewModel> {
  constructor() {
    super();
  }

  override initHub(): void {
    super.initHub(
      `${environment.communicationSignalrApi}/messageNotificationHub`
    );
  }

  public addDataListener(): void {
    this.hubConnection.on('OnMessageNotificationReceived', data => {
      this.streamReceivedData.emit(data);
    });
  }
}
